// extracted by extract-css-chunks-webpack-plugin
module.exports = {"star":"_3WOzFS"};